import Box from "@mui/material/Box";
import { Product } from "../../../../gobalType";
import { PATH_IMAGE_URL } from "../../../../services/api.constant";

interface PotsProductGridProps {
  products: Product[];
  onProductClick: (product: Product) => void;
}

const PotsProductGrid = ({ products, onProductClick }: PotsProductGridProps) => {
  if (!products.length) {
    return null;
  }

  return (
    <Box
      className="pots-grid"
      sx={{
        /* CSS Grid + gap — không margin âm như MUI Grid → không lệch trái/phải */
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          sm: "repeat(3, minmax(0, 1fr))",
          md: "repeat(4, minmax(0, 1fr))",
        },
        gap: { xs: 2, sm: 5 },
        width: "100%",
        maxWidth: "100%",
        margin: 0,
        boxSizing: "border-box",
      }}
    >
      {products.map((product, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "stretch",
            minWidth: 0,
            width: "100%",
          }}
        >
          <Box
            className="item-pots"
            sx={{
              width: { xs: "100%", sm: "190px", md: "180px", lg: "215px" },
              maxWidth: { xs: "100%", sm: "190px", md: "180px", lg: "215px" },
            }}
            onClick={() => onProductClick(product)}
          >
            <Box
              className="image-pots"
              sx={{
                borderBottomRightRadius: "10px",
                borderBottomLeftRadius: "10px",
                width: {
                  xs: "100%",
                  sm: "170px",
                  md: "180px",
                  lg: "215px",
                },
                height: {
                  xs: "auto",
                  sm: "170px",
                  md: "170px",
                  lg: "220px",
                },
                aspectRatio: { xs: "1 / 1", sm: "auto" },
                paddingTop: { sm: 1, md: 0 },
              }}
              component="img"
              src={`${PATH_IMAGE_URL + product?.thumbnail?.[0]?.image_path}`}
              alt="image"
            />
            <div className="info-name-pots">{product.name}</div>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default PotsProductGrid;
